import {
  AWS4Signer,
  AWS4SignerConfig,
  AWSRequestConfig,
  Credentials,
  Signer
} from '../../signer';

/** AWS4 Signer configuration */
const signerConfig: AWS4SignerConfig = {
  host: window.__env__.HOST,
  service: window.__env__.AWS_SERVICE,
  region: window.__env__.AWS_REGION
};

/** Singer Sigleton instance */
let _instance: Signer<AWS4SignerConfig, AWSRequestConfig, Credentials> | undefined;

if (!_instance) {
  _instance = new AWS4Signer(signerConfig);
}

const signer = _instance;

export { signer };
